import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-term-services',
  templateUrl: './term-services.component.html',
  styleUrls: ['./term-services.component.scss']
})
export class TermServicesComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.metaTagService.updateTag({
      name: 'Trinka is the only AI grammar and language checker for academic & technical writing. Trinka goes beyond grammar and makes your writing publication ready with enhancements for tone, style, readability, and more!',
      content: "grammar checker for academic and technical writing , advanced grammar correction, academic writing assistant, technical writing assistant, advanced grammar check, automated grammar checker, automated grammar correction, academic writing AI too"
    });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/termsofservices' });
  }

}
